import { Capacitor } from '@capacitor/core';

import mainCharPng from '/img/characters/contract-char-v4.png';
import mainCharWebp from '/img/characters/contract-char-v4.webp';

type TutorialDialogType =
  | 'shop-tutorial'
  | 'roll-craft-tutorial'
  | 'partners-tutorial'
  | 'product-of-day-tutorial';

interface TutorialDialogConfig {
  text: string;
  title?: string;
  buttonText?: string;
  route?: string;
  callback?: () => void;
}

const tutorialDialogs: Record<TutorialDialogType, TutorialDialogConfig> = {
  'shop-tutorial': {
    text: "You've reached Level 4! The Shop is unlocked, purchase upgrades, boost your progress, and unlock new opportunities",
  },
  'roll-craft-tutorial': {
    text: 'You’ve reached Level 3! Roll the dice, move across the board, collect rewards and prizes',
  },
  'partners-tutorial': {
    text: "You've reached level 5! The Partners section is unlocked, invite players using your referral link and earn rewards, including USD, from their shop purchases.",
  },
  'product-of-day-tutorial': {
    // The native app has no USD rewards
    text: Capacitor.isNativePlatform()
      ? 'You’ve reached Level 2, complete contracts with "Daily Goods", win prizes and tickets for weekly draws'
      : 'You’ve reached Level 2, complete contracts with "Daily Goods", win USD, as well as tickets for weekly draws',
  },
};

const tutorialCharacter = {
  png: mainCharPng,
  webp: mainCharWebp,
  config: {
    left: '0',
  },
};

export { tutorialCharacter, tutorialDialogs };
export type { TutorialDialogConfig, TutorialDialogType };
